// Returns an E.164-formatted string like '+4799999999' or undefined when either part is empty.
export function toE164(
    dialCode: string | undefined,
    number: string | undefined,
): string | undefined {
    const cc = (dialCode ?? '').replace(/\D/g, '');
    const num = (number ?? '').replace(/\D/g, '');
    if (!cc || !num) return undefined;
    return `+${cc}${num}`;
}
